import type { FaireProductEntity } from "../../entity_types/product";

export const p_live_pistakio_creamy_pistachio_spread: FaireProductEntity = {
  token: "p_live_pistakio_creamy_pistachio_spread",
  type: "product",
  name: "Creamy Pistachio Spread",
  brandToken: "b_live_pistakio",
  brandName: "Pistakio",
  imageUrl:
    "https://cdn.faire.com/fastly/50a69923668255638997af41951ddc6525614459b3f9a45076a977b3a7dfb737.webp?bg-color=FFFFFF&fit=crop&format=jpg&height=400&width=400",
  priceDollars: 11.18,
  msrpDollars: 15,
  description: "Creamy pistachio spread used in Live Shopping mocks.",
  categoryTokens: ["cat_food-drink"],
  tags: ["live-shopping", "bestseller", "spreads"],
  isBestseller: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "live-shopping-migration",
  },
};
